"use client";

import React, { useState } from "react";
import { useAppStore } from "@/store/useAppStore";
import { FeedbackModal } from "./modals/FeedbackModal";
import { FirstChallengeButton } from "../ui/FirstChallengeButton";

export const HeroSection = () => {
  const { activeTab } = useAppStore();
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState<{
    type: "success" | "error";
    title: string;
    message: string;
    points: number;
    emoji: string;
  } | null>(null);

  return (
    <>
      {activeTab === "home" && (
        <div className="min-h-[calc(100dvh-64px)] flex items-center">
          <div className="max-w-3xl mx-auto px-5 md:px-8 py-20">
            <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-[1.05] tracking-[-2px]">
              Beat your
              <br />
              own brain
            </h2>
            <p className="text-lg md:text-xl text-[#808080] mb-10 max-w-lg leading-relaxed">
              Predict outcomes, outsmart cognitive biases, and master the
              behavioral economics that drive real-world decisions.
            </p>
            <div className="flex items-center gap-4">
              <FirstChallengeButton />
            </div>
          </div>
        </div>
      )}
      {showModal && modalContent && (
        <FeedbackModal
          handleContinue={() => setShowModal(false)}
          type={modalContent.type}
          showConfetti={modalContent.type === "success"}
        >
          <div className="text-6xl mb-4">{modalContent.emoji}</div>
          <h2 className="text-2xl font-bold text-white mb-4">
            {modalContent.title}
          </h2>
          <p className="text-[#808080] mb-6 leading-relaxed">
            {modalContent.message}
          </p>
          <div
            className={`text-xl font-bold mb-4 ${
              modalContent.type === "success"
                ? "text-green-400"
                : "text-red-400"
            }`}
          >
            {modalContent.points > 0 ? "+" : ""}
            {modalContent.points} points
          </div>
        </FeedbackModal>
      )}
    </>
  );
};
